import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document, PicklistValue } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-array-column',
    templateUrl: './array-column.component.html',
    styleUrls: ['./array-column.component.scss'],
    standalone: false
})
export class ArrayColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    const fieldValue = this.document?.[this.field.systemName];

    if(!!fieldValue) {
      return fieldValue.join(',');
    }
  
    return '';
  }
}
